import { Location, SearchFilter } from '@rygen/rygen-ui/model';

export class LocationFilters extends SearchFilter<Location> {
  locationId?: number;
  locationName?: string;
  locationCode?: string;
  addressLine1?: string;
  addressLine2?: string;
  addressLine3?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;

  constructor(opts?: Partial<LocationFilters>) {
    super(opts);

    if (opts?.locationId != null) {
      this.locationId = opts.locationId;
    }
    if (opts?.locationName != null) {
      this.locationName = opts.locationName;
    }
    if (opts?.locationCode != null) {
      this.locationCode = opts.locationCode;
    }
    if (opts?.addressLine1 != null) {
      this.addressLine1 = opts.addressLine1;
    }
    if (opts?.addressLine2 != null) {
      this.addressLine2 = opts.addressLine2;
    }
    if (opts?.addressLine3 != null) {
      this.addressLine3 = opts.addressLine3;
    }
    if (opts?.city != null) {
      this.city = opts.city;
    }
    if (opts?.state != null) {
      this.state = opts.state;
    }
    if (opts?.postalCode != null) {
      this.postalCode = opts.postalCode;
    }
    if (opts?.country != null) {
      this.country = opts.country;
    }

    this.pageSize = opts?.pageSize ?? 10;
    this.sortField = opts?.sortField ?? 'name';
    this.sortDirection = opts?.sortDirection ?? 'ASC';
  }
}
